import { css } from 'reakit/styled';
import { theme, palette } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
var Rating = styled(Box).withConfig({
  displayName: "styled__Rating",
  componentId: "sc-1kw6xuh-0"
})(["&{", ";}"], theme('fannypack.Rating.base'));
var starSizes = {
  small: css(["&{width:1rem;height:1rem;}&{", ";}"], theme('fannypack.Rating.Star.sizes.small')),
  default: css(["&{", ";}"], theme('fannypack.Rating.Star.sizes.default')),
  medium: css(["&{width:2rem;height:2rem;}&{", ";}"], theme('fannypack.Rating.Star.sizes.medium')),
  large: css(["&{width:3rem;height:3rem;}&{", ";}"], theme('fannypack.Rating.Star.sizes.large'))
};
var RatingStar = styled(Box).withConfig({
  displayName: "styled__RatingStar",
  componentId: "sc-1kw6xuh-1"
})(["width:1.5rem;height:1.5rem;&{", ";}", ";& path{fill:", ";}"], theme('fannypack.Rating.Star.base'), function (props) {
  return props.size ? starSizes[props.size || ''] : null;
}, function (props) {
  return props.active ? theme('fannypack.Rating.Star.color')(props) || 'gold' : palette('white800');
});
export { Rating, RatingStar, starSizes };